const hasContactFields = (data) =>
  Boolean(data?.adreca && data?.telefons && data?.email);

/**
 * Extract contact info from a pagina-inicial REST payload.
 * Supports legacy Dexterity fields at root and Volto homepageContact blocks.
 */
export function extractHomepageContact(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  if (hasContactFields(payload)) {
    return {
      adreca: payload.adreca,
      telefons: payload.telefons,
      email: payload.email,
    };
  }

  const blocks = payload.blocks;
  if (!blocks || typeof blocks !== 'object') {
    return null;
  }

  for (const block of Object.values(blocks)) {
    if (block?.['@type'] === 'homepageContact' && hasContactFields(block)) {
      return {
        adreca: block.adreca,
        telefons: block.telefons,
        email: block.email,
      };
    }
  }

  return null;
}
